const getProductApiUrl = ({ locale, wcs, brand, params }) => {
  const brandSite = brand.brandId === 'nap' ? `nap_${locale.country}` : `mrp_${locale.country}`
  const { seoUrl, sort, pageNumber, productsPerPage } = params
  const localeKey = locale?.locale ? locale.locale : 'en_GB'
  const wcsUrlConfig = typeof window === 'undefined' ? wcs.internal : wcs.external
  const baseUrl = `${wcsUrlConfig.baseUrl}${wcs.productsByCategoryPath}`
  const url = baseUrl
    .replace('{{brandSite}}', brandSite)
    .replace('{{seoUrl}}', seoUrl)
    .replace('{{pageSize}}', productsPerPage)
    .replace('{{pageNumber}}', pageNumber)
    .replace('{{locale}}', localeKey.toLowerCase())

  if (sort) {
    return `${url}&orderBy=${sort}`
  }
  return url
}

const getProductApiHeaders = ({ wcs }) => {
  const wcsUrlConfig = typeof window === 'undefined' ? wcs.internal : wcs.external

  return wcsUrlConfig.clientId ? { 'X-IBM-Client-Id': wcsUrlConfig.clientId } : {}
}

const getProductsListParameters = (str = '') => {
  try {
    const productsList = JSON.parse(str)
    return { ...productsList, key: str }
  } catch (e) {
    return { key: str }
  }
}

export { getProductApiUrl, getProductApiHeaders, getProductsListParameters }
